import { memo } from "react";
import ToggleSwitcher from "../shared/ToggleSwitcher";
import clickSound from "../../../assets/audio/click.wav";
import { useAudioEffects } from "../../../../../hooks/use-audio-effects";

interface LightSwitchProps {
  name: string;
  subName: string;
  isOn: boolean;
  icon: React.ReactNode;
  onToggle: () => void;
}

const LightSwitch = memo<LightSwitchProps>(
  ({ name, subName, isOn, icon, onToggle }) => {
    const { playEffect } = useAudioEffects();

    return (
      <button
        onClick={() => {
          playEffect(clickSound);
          onToggle();
        }}
        className={`w-full flex items-center gap-3 border border-white/[0.07] rounded-sm px-3 py-[9px] transition-colors text-left bg-gradient-to-l ${isOn ? "from-[#4a5924] via-[#191818] to-[#191818]" : "from-[#4f1617]  via-[#191818] to-[#191818]"}`}
      >
        {icon}

        <div className="flex-1 min-w-0">
          <p className="text-white text-[15px] leading-[1]">{name}</p>
          <p className="text-white/50 text-[13px] mt-0.5">{subName}</p>
        </div>

        <ToggleSwitcher isOn={isOn} />
      </button>
    );
  },
);

LightSwitch.displayName = "LightSwitch";
export default LightSwitch;
